const actions = {
  SET_STATE: 'reactions/SET_STATE',
  FLOAT_REACTION: 'reactions/FLOAT_REACTION',
  SEND_REACTION: 'reactions/SEND_REACTIONS'
}

export default actions
